import { useEffect, useState } from 'react';
import { useCookieValue } from './hooks';

/**
 * This hook listens to messages from the AEM Sites editor, when in editing mode
 * and triggers a re-render of components using the hook.
 */
export const useEditorEvents = () => {
  const [, setState] = useState(0);
  const [wcmmode] = useCookieValue('wcmmode');

  const onMessage = (event: MessageEvent) => {
    // Drop events from unknown origins
    if (event.origin !== window.location.origin) {
      return;
    }

    // Drop events that are not AEM Sites editor commands
    if (!event?.data?.msg || event?.data?.msg !== 'cqauthor-cmd') {
      return;
    }

    // Skip commands that do not require a re-render
    if (event?.data?.data?.cmd === 'toggleClass') {
      return;
    }

    // Update state to force re-render
    setState((state) => state + 1);
    const evt = new CustomEvent('author-content-update', {});
    window.dispatchEvent(evt);
  };

  useEffect(() => {
    // Only during editing
    if (wcmmode !== 'edit') {
      return;
    }

    window.addEventListener('message', onMessage, false);
    return () => {
      window.removeEventListener('message', onMessage, false);
    };
  }, []);
};
